<div class="producer-video-link" [ngStyle]="{ 'z-index': zIndex}"
    *ngIf="video && video.url && video.clickThruUrl && video.player">
    <a target="_blank" [href]="video.clickThruUrl">
        <mat-icon>touch_app</mat-icon>
    </a>
</div>
<div [id]="'video-hls-' + uuid" class="video-player" [hidden]="!video?.player">
</div>